import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type MarkForDeletionTarget = {
    companyId: string;
    inactivityNotificationDate?: string | null;
};

type MarkForDeletionState = {
    companyId: string;
    inactivityNotificationDate: string | null;
};

const initialState: MarkForDeletionState = {
    companyId: '',
    inactivityNotificationDate: null,
};

export const markForDeletion = createSlice({
    name: 'markForDeletion',
    initialState,
    reducers: {
        setMarkCompanyId: (state, action: PayloadAction<MarkForDeletionTarget | string | undefined>) => {
            const target =
                typeof action.payload === 'string' ? { companyId: action.payload } : action.payload;
            state.companyId = target?.companyId ?? '';
            state.inactivityNotificationDate = target?.inactivityNotificationDate ?? null;
        },
    },
});

export const { setMarkCompanyId } = markForDeletion.actions;
